import { usePledgeClaimCancelledQuery } from '../data-access/queries/usePledgeClaimCancelledQuery';

export const useWCPledgeClaimCancelledPledgePost = () => {
	const {
		error,
		isError,
		isPending,
		isSuccess,
		mutateAsync: claimCancelledPledgeAsync
	} = usePledgeClaimCancelledQuery();

	const claimCancelledPledgeMutation = ({
		campaignId,
		teamIds,
		transactionHash
	}: {
		campaignId: string;
		teamIds: Array<string>;
		transactionHash: string;
	}) => {
		return claimCancelledPledgeAsync({ data: { campaignId, teamIds, transactionHash } });
	};

	return {
		claimCancelledPledgeError: error,
		claimCancelledPledgeMutation,
		isClaimCancelledPledgeError: isError,
		isClaimCancelledPledgePosting: isPending,
		isClaimCancelledPledgeSuccess: isSuccess
	};
};
